const normalizeQuestionPart = (value = '') => String(value || '')
  .replace(/\s+/g, ' ')
  .trim();

const FOLLOW_UPS_BY_CATEGORY = {
  medication: [
    'Were there medication changes?',
    'Any side effects noted?',
    'What happened afterward?',
  ],
  medical: [
    'Compare to last month',
    'What symptoms changed nearby?',
    'Has this happened before?',
  ],
  behavior: [
    'What helped them calm?',
    'Any common triggers?',
    'Has this happened before?',
  ],
  sleep: [
    'Compare to last month',
    'What affected sleep?',
    'Which night was hardest?',
  ],
  food: [
    'How was appetite this week?',
    'Any food refusal patterns?',
    'What helped with eating?',
  ],
  feeding: [
    'How was appetite this week?',
    'Any food refusal patterns?',
    'What helped with eating?',
  ],
  therapy: [
    'What went well in therapy?',
    'Any concerns to share?',
    'What should we watch next?',
  ],
};

const DEFAULT_FOLLOW_UPS = [
  'Compare to last month',
  'What might be connected?',
  'Show related context',
];

const getPrimarySourceCategory = (sources = []) => {
  const category = String(sources?.[0]?.category || '').trim().toLowerCase();
  if (category === 'meds') return 'medication';
  if (category === 'health') return 'medical';
  return category;
};

export const buildAskFollowUpQuestion = ({
  followUpQuestion = '',
  previousQuestion = '',
} = {}) => {
  const followUp = normalizeQuestionPart(followUpQuestion);
  const previous = normalizeQuestionPart(previousQuestion);

  if (!followUp) return '';
  if (!previous) return followUp;

  return `Original question: ${previous}\nFollow-up question: ${followUp}\nAnswer the follow-up using the original question as context.`;
};

export const getAskFollowUpSuggestions = ({ sources = [] } = {}) => {
  const category = getPrimarySourceCategory(sources);
  return FOLLOW_UPS_BY_CATEGORY[category] || DEFAULT_FOLLOW_UPS;
};

export default buildAskFollowUpQuestion;
